//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import tidalTransitionExpand from '@tidal/styles-animation/src/components/tidal-transition-expand.vue';
import tidalIcon from '@tidal/styles-icons/src/components/tidal-icon.vue';
import { generalAdd, generalArrowDown } from '@tidal/styles-icons/src/icons';

export default {
    components: {
        tidalTransitionExpand,
        tidalIcon,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        bold: {
            type: Boolean,
            default: true,
        },
        borders: {
            type: Boolean,
            default: true,
        },
        compact: {
            type: Boolean,
            default: false,
        },
        compactInner: {
            type: Boolean,
            default: false,
        },
        startOpen: {
            type: Boolean,
            default: false,
        },
        arrow: {
            type: Boolean,
            default: false,
        },
        iconRight: {
            type: Boolean,
            default: false,
        },
        noHeadings: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            open: this.startOpen,
        };
    },
    computed: {
        accordionID() {
            let hash = 0;

            const nameLength = this.title.length;

            for (let i = 0; i < nameLength; i++) {
                hash = ((hash << 5) - hash) + this.title.charCodeAt(i);
                hash |= 0; // Convert to 32bit integer
            }

            return `accordion-${hash}`;
        },
        /** @return {Record<'generalAdd', string>} */
        icons() {
            return {
                generalAdd,
                generalArrowDown,
            };
        },
    },
};
